"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRC = void 0;
var IRC;
(function (IRC) {
    IRC["RPL_WELCOME"] = "001";
    IRC["RPL_YOURHOST"] = "002";
    IRC["RPL_CREATED"] = "003";
    IRC["RPL_MYINFO"] = "004";
    IRC["RPL_ISUPPORT"] = "005";
    IRC["RPL_MAP"] = "006";
    IRC["RPL_MAPEND"] = "007";
    IRC["ERR_NOSUCHNICK"] = "401";
    IRC["ERR_NOSUCHSERVER"] = "402";
    IRC["ERR_NOSUCHCHANNEL"] = "403";
    IRC["ERR_CANNOTSENDTOCHAN"] = "404";
    IRC["ERR_TOOMANYCHANNELS"] = "405";
    IRC["ERR_WASNOSUCHNICK"] = "406";
    IRC["ERR_TOOMANYTARGETS"] = "407";
    IRC["ERR_NOORIGIN"] = "409";
    IRC["ERR_NORECIPIENT"] = "411";
    IRC["ERR_NOTEXTTOSEND"] = "412";
    IRC["ERR_NOTOPLEVEL"] = "413";
    IRC["ERR_WILDTOPLEVEL"] = "414";
    IRC["ERR_UNKNOWNCOMMAND"] = "421";
    IRC["ERR_NOMOTD"] = "422";
    IRC["ERR_NOADMININFO"] = "423";
    IRC["ERR_FILEERROR"] = "424";
    IRC["ERR_NONICKNAMEGIVEN"] = "431";
    IRC["ERR_ERRONEUSNICKNAME"] = "432";
    IRC["ERR_NICKNAMEINUSE"] = "433";
    IRC["ERR_NICKCOLLISION"] = "436";
    IRC["ERR_USERNOTINCHANNEL"] = "441";
    IRC["ERR_NOTONCHANNEL"] = "442";
    IRC["ERR_USERONCHANNEL"] = "443";
    IRC["ERR_NOLOGIN"] = "444";
    IRC["ERR_SUMMONDISABLED"] = "445";
    IRC["ERR_USERSDISABLED"] = "446";
    IRC["ERR_NOTREGISTERED"] = "451";
    IRC["ERR_NEEDMOREPARAMS"] = "461";
    IRC["ERR_ALREADYREGISTRED"] = "462";
    IRC["ERR_NOPERMFORHOST"] = "463";
    IRC["ERR_PASSWDMISMATCH"] = "464";
    IRC["ERR_YOUREBANNEDCREEP"] = "465";
    IRC["ERR_KEYSET"] = "467";
    IRC["ERR_CHANNELISFULL"] = "471";
    IRC["ERR_UNKNOWNMODE"] = "472";
    IRC["ERR_INVITEONLYCHAN"] = "473";
    IRC["ERR_BANNEDFROMCHAN"] = "474";
    IRC["ERR_BADCHANNELKEY"] = "475";
    IRC["ERR_NOPRIVILEGES"] = "481";
    IRC["ERR_CHANOPRIVSNEEDED"] = "482";
    IRC["ERR_CANTKILLSERVER"] = "483";
    IRC["ERR_NOOPERHOST"] = "491";
    IRC["ERR_UMODEUNKNOWNFLAG"] = "501";
    IRC["ERR_USERSDONTMATCH"] = "502";
    IRC["QUOTE_PONG"] = "513";
    IRC["RPL_NONE"] = "300";
    IRC["RPL_AWAY"] = "301";
    IRC["RPL_USERHOST"] = "302";
    IRC["RPL_ISON"] = "303";
    IRC["RPL_UNAWAY"] = "305";
    IRC["RPL_NOWAWAY"] = "306";
    IRC["RPL_WHOISUSER"] = "311";
    IRC["RPL_WHOISSERVER"] = "312";
    IRC["RPL_WHOISOPERATOR"] = "313";
    IRC["RPL_WHOISIDLE"] = "317";
    IRC["RPL_ENDOFWHOIS"] = "318";
    IRC["RPL_WHOISCHANNELS"] = "319";
    IRC["RPL_WHOWASUSER"] = "314";
    IRC["RPL_ENDOFWHOWAS"] = "369";
    IRC["RPL_LISTSTART"] = "321";
    IRC["RPL_LIST"] = "322";
    IRC["RPL_LISTEND"] = "323";
    IRC["RPL_CHANNELMODEIS"] = "324";
    IRC["RPL_NOTOPIC"] = "331";
    IRC["RPL_TOPIC"] = "332";
    IRC["RPL_INVITING"] = "341";
    IRC["RPL_SUMMONING"] = "342";
    IRC["RPL_VERSION"] = "351";
    IRC["RPL_WHOREPLY"] = "352";
    IRC["RPL_ENDOFWHO"] = "315";
    IRC["RPL_NAMREPLY"] = "353";
    IRC["RPL_NAMEREPLY"] = "RPL_NAMREPLY";
    IRC["RPL_WHOSPCRPL"] = "354";
    IRC["RPL_ENDOFNAMES"] = "366";
    IRC["RPL_LINKS"] = "364";
    IRC["RPL_ENDOFLINKS"] = "365";
    IRC["RPL_BANLIST"] = "367";
    IRC["RPL_ENDOFBANLIST"] = "368";
    IRC["RPL_INFO"] = "371";
    IRC["RPL_ENDOFINFO"] = "374";
    IRC["RPL_MOTDSTART"] = "375";
    IRC["RPL_MOTD"] = "372";
    IRC["RPL_ENDOFMOTD"] = "376";
    IRC["RPL_YOUREOPER"] = "381";
    IRC["RPL_REHASHING"] = "382";
    IRC["RPL_QLIST"] = "386";
    IRC["RPL_ENDOFQLIST"] = "387";
    IRC["RPL_TIME"] = "391";
    IRC["RPL_USERSSTART"] = "392";
    IRC["RPL_USERS"] = "393";
    IRC["RPL_ENDOFUSERS"] = "394";
    IRC["RPL_NOUSERS"] = "395";
    IRC["RPL_TRACELINK"] = "200";
    IRC["RPL_TRACECONNECTING"] = "201";
    IRC["RPL_TRACEHANDSHAKE"] = "202";
    IRC["RPL_TRACEUNKNOWN"] = "203";
    IRC["RPL_TRACEOPERATOR"] = "204";
    IRC["RPL_TRACEUSER"] = "205";
    IRC["RPL_TRACESERVER"] = "206";
    IRC["RPL_TRACESERVICE"] = "207";
    IRC["RPL_TRACENEWTYPE"] = "208";
    IRC["RPL_TRACECLASS"] = "209";
    IRC["RPL_TRACELOG"] = "261";
    IRC["RPL_STATSLINKINFO"] = "211";
    IRC["RPL_STATSCOMMANDS"] = "212";
    IRC["RPL_STATSCLINE"] = "213";
    IRC["RPL_STATSNLINE"] = "214";
    IRC["RPL_STATSOLDNLINE"] = "RPL_STATSNLINE";
    IRC["RPL_STATSILINE"] = "215";
    IRC["RPL_STATSKLINE"] = "216";
    IRC["RPL_STATSQLINE"] = "217";
    IRC["RPL_STATSYLINE"] = "218";
    IRC["RPL_ENDOFSTATS"] = "219";
    IRC["RPL_UMODEIS"] = "221";
    IRC["RPL_SERVICEINFO"] = "231";
    IRC["RPL_ENDOFSERVICES"] = "232";
    IRC["RPL_SERVICE"] = "233";
    IRC["RPL_SERVLIST"] = "234";
    IRC["RPL_SERVLISTEND"] = "235";
    IRC["RPL_STATSIAUTH"] = "239";
    IRC["RPL_STATSVLINE"] = "240";
    IRC["RPL_STATSLLINE"] = "241";
    IRC["RPL_STATSUPTIME"] = "242";
    IRC["RPL_STATSOLINE"] = "243";
    IRC["RPL_STATSHLINE"] = "244";
    IRC["RPL_LUSERCLIENT"] = "251";
    IRC["RPL_LUSEROP"] = "252";
    IRC["RPL_LUSERUNKNOWN"] = "253";
    IRC["RPL_LUSERCHANNELS"] = "254";
    IRC["RPL_LUSERME"] = "255";
    IRC["RPL_ADMINME"] = "256";
    IRC["RPL_ADMINLOC1"] = "257";
    IRC["RPL_ADMINLOC2"] = "258";
    IRC["RPL_ADMINEMAIL"] = "259";
    IRC["RPL_MONONLINE"] = "730";
    IRC["RPL_MONOFFLINE"] = "731";
    IRC["RPL_MONLIST"] = "732";
    IRC["RPL_ENDOFMONLIST"] = "733";
    IRC["ERR_MONLISTFULL"] = "734";
    IRC["RPL_SASLLOGIN"] = "900";
    IRC["RPL_SASLSUCCESS"] = "903";
    IRC["RPL_SASLFAILED"] = "904";
    IRC["RPL_SASLERROR"] = "905";
    IRC["RPL_SASLABORT"] = "906";
    IRC["RPL_SASLALREADYAUTH"] = "907";
})(IRC = exports.IRC || (exports.IRC = {}));
//# sourceMappingURL=irc.js.map